import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef, useState, useEffect } from "react";
import './index.css';const getSpinnerSize = (size) => {
  switch (size) {
    case "xxsmall":
      return 16;
    case "xsmall":
      return 20;
    case "small":
      return 24;
    case "medium":
      return 48;
    case "large":
    default:
      return 96;
  }
};
const getStrokeSize = (size) => {
  switch (size) {
    case "xxsmall":
    case "xsmall":
      return getSpinnerSize(size) / 5;
    case "small":
    case "medium":
      return getSpinnerSize(size) / 6;
    case "large":
    default:
      return getSpinnerSize(size) / 10;
  }
};
const LoadingIndicatorSpinner = forwardRef(
  ({
    size = "large",
    loadingText,
    colorVariant = "onWhite",
    className,
    delayMs = 300,
    ...props
  }, ref) => {
    const [showSpinner, setShowSpinner] = useState(!(delayMs > 0));
    const spinnerSize = getSpinnerSize(size);
    const stroke = getStrokeSize(size);
    const cx = spinnerSize / 2;
    const cy = spinnerSize / 2;
    const innerRadius = spinnerSize / 2 - stroke / 2;
    useEffect(() => {
      let timer;
      if (delayMs) {
        timer = setTimeout(() => {
          setShowSpinner(true);
        }, delayMs);
      }
      return () => clearTimeout(timer);
    }, [delayMs]);
    return showSpinner ? /* @__PURE__ */ jsxs(
      "div",
      {
        ...props,
        className: `spinnerContainer ${size} ${colorVariant}${className ? ` ${className}` : ""}`,
        "data-stb-spinner": "current",
        "data-component-info": "pretzel-spinner",
        role: "progressbar",
        "aria-busy": true,
        "aria-label": loadingText ?? "Loading...",
        ref,
        children: [
          /* @__PURE__ */ jsxs(
            "svg",
            {
              className: `spinner ${colorVariant}`,
              version: "1.1",
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: `0 0 ${spinnerSize} ${spinnerSize}`,
              height: spinnerSize,
              width: spinnerSize,
              children: [
                /* @__PURE__ */ jsx(
                  "circle",
                  {
                    className: "spinnerTrack",
                    cx,
                    cy: cx,
                    r: innerRadius,
                    fill: "none",
                    strokeWidth: stroke
                  }
                ),
                /* @__PURE__ */ jsx(
                  "circle",
                  {
                    className: "spinnerInMotion",
                    cx,
                    cy,
                    r: innerRadius,
                    fill: "none",
                    strokeWidth: stroke
                  }
                )
              ]
            }
          ),
          loadingText && size === "large" && /* @__PURE__ */ jsx("p", { className: "font-body", children: loadingText }),
          loadingText && size === "medium" && /* @__PURE__ */ jsx("p", { className: "font-small", children: loadingText })
        ]
      }
    ) : null;
  }
);
export {
  LoadingIndicatorSpinner,
  LoadingIndicatorSpinner as default
};
